    import { React, useNavigate, useState, useParams, useEffect } from '../../utils/globalImports';
    import { AppLayout, FilterCard, CustomDataTable, useApi, Toaster, validationMessages, CustomConfirmDialog, CustomBackdrop, ProposalType, ProposalTypeId } from '../../utils/globalImports';
    import { ApiResponse } from '../../services/apiService';


    interface Proposal {

        proposalId: number;
        projectId: number;
        proposalNumber: string;
        proposalName: string;
        proposalStageName:string;
        proposalValue:number,
        proposalInstructedValue:number,
        proposalType: string;
        status?: number;
    }

    interface Project {
        projectName: string;
    }


    const getProposalTypeId = (value: string): ProposalTypeId | undefined =>
        Object.keys(ProposalType).find(key => ProposalType[key as unknown as ProposalTypeId] === value) as ProposalTypeId | undefined;

    const Proposals: React.FC = () => {

        const [proposalData, setProposalData] = useState<any[]>([]);
        const [filteredData, setFilteredData] = useState<any[]>([]);
        const [selectedProposal, setSelectedProposal] = useState<any | null>(null);
        const [dialogOpen, setDialogOpen] = useState(false); // State to manage confirm dialog "open/close" state
        const [copyDialogOpen, setCopyDialogOpen] = useState(false); // State to manage confirm dialog "open/close" state
        const [isOn, setIsOn] = useState<boolean>();  // State to manage the toggle button's "on/off" state
        const [toast, setToast] = useState({ open: false, message: "", type: "success" });
        const { execute, loading } = useApi();
        const [currentStatus, setCurrentStatus] = useState<string[]>(['Active']); // State to manage the current status of proposals

        const { projectId } = useParams<{ projectId?: string }>(); // Get projectId from URL
        const { projectName } = useParams<{ projectName?: string }>(); // Get projectId from URL
        const userId = Number(localStorage.getItem("userId"));

        const props = { showProposalTypeDropdown: true, title: projectName, actionText: 'Add Proposal', searchbarText: validationMessages.proposal_searchText }

        useEffect(() => {
            // fetchProject()
            fetchProposals();
        }, []);  // The empty dependency array ensures it only runs once when the component mounts

        const navigate = useNavigate();
        const handleNavigate = (proposalId?: number) => {
            if (proposalId) navigate(`/proposal/add-proposal/${projectId}/${proposalId}/${projectName}`);
            else navigate(`/proposal/add-proposal/${projectId}/${projectName}`);
        }

        const handleArrowBackNavigation = () => {
            navigate(`/project/edit-projects/${projectId}/general`);
        }

        const sortOptions = [
            { value: "Proposal Number", text: "Proposal Number" },
            { value: "Proposal Name", text: "Proposal Name" },
        ];


        // Fetch project
        // const fetchProject = async () => {
        //     const { data } = await execute<Project>('get', `/Project/GetProject/${projectId}`);
        //     if (data) setTitle(data.projectName);
        //     else {
        //         navigate('/404');  // Redirect to a Not Found page
        //     }
        // };

        // Fetch proposals
        const fetchProposals = async () => {
            const { data } = await execute<Proposal[]>('get', `/Proposal/projects/${projectId}/proposals`);
            if (data) {
                // Use reduce to exclude unwanted fields
                const proposalData = data
                    .map((proposal) => {
                        const { proposalId, projectId, proposalNumber, proposalName,proposalStageName,proposalValue,proposalInstructedValue, proposalType, status } = proposal;
                        const Status = status === 1 ? 'Active' : 'Inactive';
                        return { 
                            proposalId, projectId, 
                            "Proposal Number": proposalNumber, 
                            "Proposal Name": proposalName, 
                            "Proposal Type": proposalType,
                            "Proposal Stage":proposalStageName,
                            "Proposal value":proposalValue.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' }),
                            "Instructed Value":proposalInstructedValue.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' }), 
                            Status };
                    });
                setProposalData(proposalData);
                //  Filter for status = 1(Active) and set to filteredData
                const activeProposals = proposalData
                    .filter((proposal) => currentStatus.includes(proposal.Status))
                // .sort((a, b) =>
                //     a["Proposal Number"].localeCompare(b["Proposal Number"], undefined, { sensitivity: 'base' }) ||
                //     a["Proposal Name"].localeCompare(b["Proposal Name"], undefined, { sensitivity: 'base' })
                // );
                setFilteredData(activeProposals);
            }
        };

        // filter Data
        const handleSearchClientData = (query: string, status: Number, category?: number, region?: number, contactType?: number, date?: string, proposalType?: number) => {
            const lowerCaseQuery = query.toLowerCase();

            // Map status strings to corresponding numbers
            const statusMapping: Record<string, number> = {
                Active: 1,
                Inactive: 0,
            };

            const filtered = proposalData.filter((item) => {
                // Convert item.Status to its numeric equivalent or skip if it doesn't match
                const itemStatus = statusMapping[item.Status] ?? -1;

                const matchesQuery =
                    item["Proposal Number"].toLowerCase().includes(lowerCaseQuery) ||
                    item["Proposal Name"].toLowerCase().includes(lowerCaseQuery);

                const proposalTypeId = getProposalTypeId(item["Proposal Type"]);

                const matchProposalType = proposalType === -1 || Number(proposalTypeId) === proposalType;

                const matchesStatus =
                    status === -1 || status === 2 || itemStatus === status;

                return matchesQuery && matchProposalType && matchesStatus;
            })
                .sort((a, b) =>
                    a["Proposal Number"].localeCompare(b.clientName, undefined, { sensitivity: 'base' }) ||
                    a["Proposal Name"].localeCompare(b.clientNumber, undefined, { sensitivity: 'base' })
                );
            setFilteredData(filtered);
            setCurrentStatus(
                status === 0
                    ? ['Inactive'] // When status is 0, set currentStatus to 'Inactive'
                    : status === -1 || status === 2
                        ? ['Active', 'Inactive'] // When status is -1 or 2, set currentStatus to both 'Active' and 'Inactive'
                        : status === 1
                            ? ['Active'] // When status is 1, set currentStatus to 'Active'
                            : currentStatus // Fallback to the current value if no conditions are met
            );
        }

        const handleEdit = (proposal: any) => {
            handleNavigate(proposal.proposalId)
        };

        const handleCopy = (row: any) => {
            setCopyDialogOpen(true)
            setSelectedProposal(row);
        }

        const handleToggleState = (row: any) => {
            if (row.Status === 'Inactive') {
                setIsOn(false)
            } else {
                setIsOn(true)
            }
            setSelectedProposal(row);
            setDialogOpen(true);
        }

        const handleDialogCancel = () => {
            setDialogOpen(false);
            setSelectedProposal(null); // Clear selected row
        }

        const handleDialogConfirm = async () => {
            if (!selectedProposal) return;

            const proposalId = selectedProposal.proposalId;
            const isCurrentlyActive = selectedProposal.Status === 'Active';
            const updatedStatus = isCurrentlyActive ? 0 : 1;

            try {
                const { data } = await execute('get', `/proposal/proposals/${proposalId}/details`);

                if (!data) {
                    setToast({ open: true, message: "Failed to fetch proposal details.", type: "error" });
                    return;
                }

                const updatedProposal = {
                    ...data,
                    status: updatedStatus,
                };

                const response: ApiResponse<any> = await execute('put', `/Proposal/proposals/${proposalId}`, updatedProposal);

                setToast({
                    open: true,
                    message: response.error || response.data || "Proposal status updated",
                    type: response.error ? "error" : "success",
                });

                setSelectedProposal(null); // Clear selected row after update
                fetchProposals(); // Refresh the proposal list

            } catch (error) {
                setToast({ open: true, message: "An unexpected error occurred.", type: "error" });
            } finally {
                setDialogOpen(false);
            }
        };

        const handleConfirmCopy = async () => {
            try {
                const response: ApiResponse<any> = await execute('post', `/Proposal/CloneProposal/${selectedProposal.proposalId}/${userId}`);
                if (response!) {
                    if (response.error) {
                        // If there's an error in the response, display the error message
                        setToast({ open: true, message: validationMessages.common_Error, type: "error" });
                    } else {
                        // If the response is successful, display the success message
                        setToast({ open: true, message: validationMessages.common_CopySucess("Proposal"), type: "success" });
                        fetchProposals();
                    }
                }
                setSelectedProposal(null); // Clear selected row
            }
            finally {
                setCopyDialogOpen(false)
            }
        }


        return (
            <AppLayout>
                <FilterCard {...props} handleArrowBackNavigation={() => handleArrowBackNavigation()} handleModalOrNavigate={() => handleNavigate()} handleSearch={handleSearchClientData} ></FilterCard>
                <CustomDataTable
                    rows={filteredData}
                    actionText="Proposal"
                    sortOptions={sortOptions}
                    onRowEdit={handleEdit}
                    onRowDoubleClick={handleEdit}
                    onRowCopy={handleCopy}
                    onToggleClick={handleToggleState}
                    isDialogOpen={dialogOpen}
                    isToggleOn={isOn}
                    handleCancel={handleDialogCancel}
                    handleConfirm={handleDialogConfirm}
                    noResultMessage={validationMessages.common_RecordNotFound("proposals")}
                >

                </CustomDataTable>

                <CustomBackdrop open={loading} />
                <Toaster open={toast.open} message={toast.message} type={toast.type as "success" | "error"} onClose={() => setToast({ ...toast, open: false })} />
                <CustomConfirmDialog
                    open={copyDialogOpen}
                    title={validationMessages.common_CopyTitle}
                    message={validationMessages.common_CopyMessage("proposal")}
                    onConfirm={handleConfirmCopy}
                    onCancel={() => {
                        setCopyDialogOpen(false)
                    }}
                    onClose={() => {
                        setCopyDialogOpen(false)
                    }}
                />
            </AppLayout>
        );
    }

    export default Proposals;